import Service from "../../Services";

const Location = {
  namespaced : true,
  state : {
    form : {
      branch_id : '',
      tcdc_mini_id : '',
      description_en : '',
      description_th : '',
      address : '',
      postal_address : '',
      opening_hours_detail : '',
      lat : '',
      lon : '',
      attached_website : '',
      opening_hours : [],
    }
  },
  mutations : {
    GET_FORM:(state,res)=>{
      state.form = res;
    },
    CLEAR_FORM_DATA :(state)=>{
      state.form = {
        branch_id : '',
        tcdc_mini_id : '',
        description_en : '',
        description_th : '',
        address : '',
        postal_address : '',
        opening_hours_detail : '',
        lat : '',
        lon : '',
        attached_website : '',
        opening_hours : [],
      }
    }
  },
  actions : {
    getLocation({commit},page){
      return Service.LocationAPI.getLocation(page);
    },
    showLocation({commit},id){
      return Service.LocationAPI.showLocation(id);
    },
    saveLocation({commit},{id,data}){
      if(id){
        return Service.LocationAPI.updateLocation(id,data);
      }else{
        return Service.LocationAPI.createLocation(data);
      }
    },
    deleteLocation({commit},id){
      return Service.LocationAPI.deleteLocation(id);
    },
    setFormLocation({commit},res){
      commit('GET_FORM',res);
    },
    clearFormData({commit}){
      commit('CLEAR_FORM_DATA');
    }
  },
}
export default Location
